<template>
  <div class="relative pt-32 bg-white h-screen">
    <div class="absolute top-32 right-0 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute bottom-32 left-0 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
      <img src="../../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img src="../../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="flex lg:px-0 md:px-8 px-5 lg:gap-40 md:gap-4 gap-4">
      <div class="lg:w-1/2 md:w-1/2 justify-center items-center mob-hidden">
        <h2 class="fsize40 md-fsize25 font-bold subtitle lg:pl-32">Register now to be a</h2>
        <span class="fsize48 md-fsize25 font-bold text-primary lg:pl-32">
          Service Provider</span
        >
        <p class="fsize20  lg:pl-32">
          A registered user gets access to curated content under Insights,
          Blogs, Podcasts, and many more.
        </p>
        <img
          src="@/assets/images/coach/hcpRegister.svg"
          alt=""
          class="object-contain w-full h-360px"
        />
      </div>
      <card class="shadow-lg w-425">
        <div class="mx-auto">
          <!-- <p class="fsize25 text-center font-semibold text-black">
            Become a Volunteer
          </p> -->
          <!-- <p class="subtitle tracking-wide fsize18">
            Welcome back, please login to your account.
          </p> -->
          <div>
            <div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(submitForm)">
                  <div v-if="!isshowform">
                    <div class="mt-4">
                      <p class="col-black font-semibold sm-fsize12">
                        Register as a <span class="text-danger">*</span>
                      </p>
                      <base-input
                        class=""
                        v-model="registerAs"
                        name="Register"
                        :rules="{ required: true }"
                      >
                        <select
                          v-model="registerAs"
                          class="form-control mb-4"
                          name="Register"
                        >
                          <option value="" disabled="true">
                            Please select an option
                          </option>
                          <option value="Volunteer">Volunteer</option>
                          <option value="Service Provider">
                            Service Provider
                          </option>
                        </select>
                      </base-input>
                      <div class="lg:flex md:flex gap-2">
                        <div class="lg:w-1/2 md:w-1/2">
                          <p class="col-black font-semibold sm-fsize12">
                            First Name <span class="text-danger">*</span>
                          </p>
                          <base-input
                            v-model="firstName"
                            placeholder="First Name"
                            :rules="{ required: true, alpha: true }"
                            name="First Name"
                            class="mb-4"
                          ></base-input>
                        </div>
                        <div class="lg:w-1/2 md:w-1/2">
                          <p class="col-black font-semibold sm-fsize12">
                            Last Name <span class="text-danger">*</span>
                          </p>
                          <base-input
                            v-model="lastName"
                            :rules="{ required: true, alpha: true }"
                            name="Last Name"
                            placeholder="Last Name"
                            class="mb-4"
                          ></base-input>
                        </div>
                      </div>
                      <p class="col-black font-semibold sm-fsize12 mt-2">
                        Email <span class="text-danger">*</span>
                      </p>
                      <base-input
                        v-model="email"
                        :rules="{ required: true, email: true }"
                        name="Email"
                        placeholder="Enter your email"
                        class="mb-4"
                      ></base-input>
                      <div class="flex gap-4 mt-4">
                        <div class="lg:w-1/4 md:w-4/12 w-5/12">
                          <p class="col-black font-semibold sm-fsize12">Country Code</p>
                          <vue-country-code
                            defaultCountry="IN"
                            enabledCountryCode
                            @onSelect="handleCountry"
                          >
                          </vue-country-code>
                        </div>
                        <div class="lg:w-3/4 md:w-8/12 w-7/12">
                          <p class="col-black font-semibold sm-fsize12">
                            Phone <span class="text-danger">*</span>
                          </p>
                          <base-input
                            :rules="{
                              numeric: true,
                              required: true,
                              min: 10,
                              max: 15,
                            }"
                            name="Mobile"
                            v-model="mobile"
                            placeholder="Enter your number"
                            class="mb-4"
                          ></base-input>
                        </div>
                      </div>
                      <div class="lg:flex md:flex gap-2 mt-2">
                        <div class="lg:w-1/2 md:w-1/2">
                          <p class="col-black font-semibold sm-fsize12">
                            Date of Birth <span class="text-danger">*</span>
                          </p>
                          <base-input
                            type="date"
                            v-model="DOB"
                            class="mb-4"
                            :rules="{ required: true }"
                            name="Date of Birth"
                            placeholder="Enter Date of birth"
                          ></base-input>
                          <!-- <base-input
                            v-model="DOB"
                            :rules="{ required: true }"
                            name="Date of Birth"
                          >
                            <el-date-picker
                              v-model="DOB"
                              type="date"
                              placeholder="Pick a date"
                              :default-value="new Date()"
                              format="dd-MM-yyyy"
                            >
                            </el-date-picker>
                          </base-input> -->
                        </div>
                        <div class="lg:w-1/2 md:w-1/2">
                          <p class="col-black font-semibold sm-fsize12">
                            Gender <span class="text-danger">*</span>
                          </p>
                          <base-input
                            class=""
                            v-model="gender"
                            :rules="{ required: true }"
                            name="Gender"
                          >
                            <select v-model="gender" class="form-control mb-4">
                              <option value="" disabled="true">
                                Please select an option
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isshowform">
                    <div class="w-full">
                      <p class="col-black font-semibold sm-fsize12 mt-4">
                        Location <span class="text-danger">*</span>
                      </p>
                      <base-input
                        v-model="location"
                        :rules="{ required: true }"
                        name="Location"
                        class=""
                      >
                        <!-- <b-form-select
                          v-model="location"
                          :options="platformOptions"
                          class="form-control mb-3"
                          value-field="item"
                          text-field="name"
                        >
                          <template #first>
                            <b-form-select-option value="" disabled
                              >Please select an option
                            </b-form-select-option>
                          </template>
                        </b-form-select> -->
                        <select v-model="location" class="form-control mb-2">
                          <option value="" disabled="true">
                            Please select an option
                          </option>
                          <option
                            v-for="location in platformOptions"
                            :key="location"
                            :value="location"
                          >
                            {{ location }}
                          </option>
                        </select>
                      </base-input>
                      <base-input
                        v-if="location === 'Other'"
                        v-model="locationOther"
                        :rules="{ required: true, alpha_spaces: true }"
                        name="Location"
                        placeholder="Please specify"
                        class="mb-4"
                      ></base-input>
                    </div>
                    <p class="col-black font-semibold sm-fsize12">
                      Profession <span class="text-danger">*</span>
                    </p>
                    <!-- <base-input
                      class=""
                      v-model="profession"
                      :rules="{ required: true }"
                      name="Profession"
                    >
                      <select v-model="profession" class="form-control mb-2">
                        <option value="" disabled="true">
                          Please select an option
                        </option>
                        <option value="Profession1">Profession1</option>
                        <option value="Profession2">Profession2</option>
                        <option value="Other">Other</option>
                      </select>
                    </base-input>
                    <base-input
                      v-if="profession === 'Other'"
                      v-model="professionOther"
                      placeholder="Please specify"
                      :rules="{ required: true, alpha_spaces: true }"
                      name="Profession"
                      class="mb-4"
                    ></base-input> -->
                    <base-input
                      v-model="profession"
                      :rules="{ required: true, alpha_spaces: true }"
                      name="Profession"
                      placeholder="Enter your Profession"
                      class="mb-4"
                    ></base-input>
                    <p class="col-black font-semibold sm-fsize12">
                      Experience <span class="text-danger">*</span>
                    </p>
                    <base-input
                      v-model="experience"
                      :rules="{ required: true, alpha_spaces: true }"
                      name="Experience"
                      placeholder="enter experience"
                      class="mb-4"
                    ></base-input>
                    <p class="col-black font-semibold sm-fsize12">
                      Expertise <span class="text-danger">*</span>
                    </p>
                    <base-input
                      v-model="expertise"
                      placeholder="expertise"
                      class="mb-4"
                      :rules="{ required: true, alpha_spaces: true }"
                      name="Expertise"
                    ></base-input>
                    <div v-if="registerAs === 'Service Provider'">
                      <p class="col-black font-semibold sm-fsize12">
                        Price <span class="text-danger">*</span>
                      </p>
                      <base-input
                        v-model="price"
                        :rules="{ required: true, numeric: true }"
                        name="Price"
                        placeholder="Service Amount"
                        class="mb-4"
                      ></base-input>
                    </div>
                  </div>
                  <div class="text-center">
                    <b-button
                      variant="primary"
                      class="mr-4 mt-4"
                      @click="isshowform = true"
                      v-if="!isshowform"
                      >Next</b-button
                    >
                    <b-button
                      variant="primary"
                      class="mr-4 mt-4"
                      v-if="isshowform"
                      @click="isshowform = false"
                      >Previous</b-button
                    >
                    <base-button
                      type="primary"
                      class="mr-4 mt-4"
                      v-if="isshowform"
                      native-type="submit"
                      >Submit</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { DatePicker } from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      isshowform: false,
      registerAs: "",
      firstName: "",
      lastName: "",
      email: "",
      mobile: null,
      DOB: null,
      gender: "",
      location: "",
      locationOther: "",
      platformOptions: [],
      profession: "",
      professionOther: "",
      experience: "",
      expertise: "",
      price: null,
      countryCode: "",
    };
  },

  computed: {
    ...mapState("respitecare", {
      get_all_location_name: "get_all_location_name",
    }),
  },
  methods: {
    async handleCountry({ name, iso2, dialCode }) {
      this.countryCode = `+${dialCode}`;
    },
    async init() {
      // console.log(this.get_all_location_name);
      this.platformOptions = this.get_all_location_name.map(
        (locationName) => locationName
      );
      this.platformOptions.push("Other");
      // console.log(this.platformOptions);
    },
    async submitForm() {
      let payload = {
        registerAs: this.registerAs,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        mobile: this.mobile,
        DOB: this.DOB,
        gender: this.gender,
        countryCode: this.countryCode,
        location:
          this.location === "Other" ? this.locationOther : this.location,
        // profession:
        //   this.profession === "Other" ? this.professionOther : this.profession,
        profession: this.profession,
        experience: this.experience,
        expertise: this.expertise,
        price:
          this.price && this.registerAs === "Service Provider"
            ? Number(this.price)
            : 0,
      };

      // console.log(payload);
      try {
        const data = await this.$store.dispatch("hcp/addVolunteerHCP", payload);

        if (data.code == 200) {
          const emailPayload = {
            userEmail: this.email,
            payload: payload,
          };
          const becomeVolunteerEmail = await this.$store.dispatch(
            "hcp/emailBecomeVolunteer",
            emailPayload
          );
          this.$swal.fire({
            text: "Volunteer Form Submitted Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          payload = {};
          this.registerAs = "";
          this.firstName = "";
          this.lastName = "";
          this.email = "";
          this.mobile = null;
          this.DOB = null;
          this.gender = "";
          this.countryCode = "";
          this.location = "";
          this.locationOther = "";
          this.profession = "";
          this.experience = "";
          this.expertise = "";
          this.price = null;
          this.$refs.formValidator.reset();
        }
      } catch (error) {
        payload = {};
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },

  async mounted() {
    await this.$store.dispatch("respitecare/get_all_location_name");
    await this.init();
  },
};
</script>
<style lang="scss">
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.form-group {
  margin-bottom: 3px;
}
.h-360px {
  height: 360px;
}
.bg-0060fe {
  background-color: #0060fe;
}
.border-4f0a4b {
  border: 0.5px solid gray;
}
.w-425 {
  width: 475px;
}
.form-control {
  border: 1px solid #830c81;
}
.vue-country-select {
  border-radius: 6px !important;
  border: 1px solid #830c81 !important;
  height: calc(1em + 1.35rem + 4px) !important;
}
</style>
